module.exports = __webpack_public_path__ + "b0b9ed3c034c849f236a16ec3230c64d.jpg";